import { FC } from 'react';
import { addSpaceNumber } from 'utils/addSpaceNumber';
import styles from './UploadSummary.module.scss';

interface UploadSummaryProps {
  sum: number;
  commission: number;
}

export const UploadSummary: FC<UploadSummaryProps> = ({ sum, commission }) => {
  return (
    <div className={styles.summarySection}>
      <div className={styles.summaryItem}>
        <p className={styles.summaryLabel}>Заказов на сумму</p>
        <p className={styles.summaryValue}>{addSpaceNumber(sum)} ₽</p>
      </div>
      <div className={styles.summaryItem}>
        <p className={styles.summaryLabel}>
          Вознаграждение оператора {addSpaceNumber(commission)} ₽
        </p>
      </div>
    </div>
  );
};
